module.exports = __webpack_public_path__ + "img/c-thermometer-img8-3.9e819733.png";